import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { clearField, DoubleDateTableFilter, getError, SmartFormContainer } from '@shared';
import * as moment from 'moment';

@Component({
  selector: 'app-double-date-filter',
  templateUrl: './double-date-filter.component.html',
  styleUrls: ['./double-date-filter.component.scss'],
})
export class DoubleDateFilterComponent extends SmartFormContainer implements OnInit {
  readonly getError = getError;
  readonly clearField = clearField;
  readonly todayDate = moment().toDate();
  @Input() config: DoubleDateTableFilter;
  @Input() sm: boolean = false;

  get control(): FormControl {
    return this.form.get(this.controlName) as FormControl;
  }

  setTodayDateTime(): void {
    this.setDateTime(this.config.fromFilter.controlName, this.todayDate);
    this.setDateTime(this.config.toFilter.controlName, this.todayDate);
  }

  setDateTime(controlName: string, date: Date): void {
    const control = this.form.get(controlName);

    if (control) {
      control.setValue(date);
      control.markAsTouched();
    }
  }

  override ngOnInit(): void {
    // We don't need this because we don't want to
    // get such control { '': null }
    void 0;
  }
}
